import { useTranslation } from "react-i18next";
import Loader from "../../../../../Dashboard/Editor/Loader/Loader";
import { Button, Modal } from "../../../../../UI";
import { ModalContainer } from "../../../../../UI/Modal";
import {
  StyledLoginModalContainer,
  StyledModalButtonContainer,
  StyledModalText,
} from "../UserAccount-styled";

const LoginModal = ({ show, handleClose, onLogin, wfpLoading }) => {
  const { t } = useTranslation("common");
  return (
    <Modal show={show}>
      <ModalContainer
        title={t("screen.widget.Account.loginModal.title")}
        handleClose={wfpLoading ? undefined : handleClose}
      >
        <StyledLoginModalContainer>
          <StyledModalText>
            {t("screen.widget.Account.loginModal.description")}
          </StyledModalText>
          <StyledModalButtonContainer>
            <Button disabled={wfpLoading} isNew onClick={handleClose}>
              <span>{t("screen.widget.Account.loginModal.close")}</span>
            </Button>

            <Button
              disabled={wfpLoading}
              position="relative"
              bg="#007DBC"
              color="#ffffff"
              isNew
              onClick={onLogin}
            >
              {wfpLoading && (
                <Loader
                  loaderStyles={{
                    position: "relative",
                    top: 9,
                  }}
                  color="#ffffff"
                  bg="transparent"
                  size="40px"
                  position="absolute"
                />
              )}
              <span style={{ opacity: wfpLoading ? 0 : 1 }}>
                {t("screen.widget.Account.loginModal.login")}
              </span>
            </Button>
          </StyledModalButtonContainer>
        </StyledLoginModalContainer>
      </ModalContainer>
    </Modal>
  );
};

export default LoginModal;
